module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bg-root"
  }, [_c('div', {
    staticClass: "background",
    style: (_vm.backgroundStyle)
  }), _vm._v(" "), _c('div', {
    staticClass: "mask",
    style: (_vm.maskStyle)
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-57f4a086"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/home/components/background.vue
// module id = 186
// module chunks = 0